/* GGG Shopify theme — small interactions */
document.addEventListener('click', function (e) {
  // PDP thumbnails
  var thumb = e.target.closest('.pdp-thumbs button[data-src]');
  if (thumb) {
    var main = document.querySelector('.pdp-main img');
    if (main) main.src = thumb.dataset.src;
  }
});
